/* eslint-disable */

import { produce } from "immer";
import {create} from "zustand";
import { LivePriceData } from "../livePrice";

// import type { LivePriceData } from "@/pages/api/livePrice";

export type LivePrice = {
  message: string;
  msgKey: string;
  pricedata: LivePriceData;
};

export const LivePriceDataIntitial = {
  blockId: "",
  discountAppliedForSale: false,
  blockIdExpireAt: "",
  purchaseTax: 0,
  buyGoldRate: 0,
  saleTax: 0,
  discountAppliedForBuy: false,
  saleGoldRateAfterDiscount: 0,
  buyGoldRateAfterDiscount: 0,
  id: "",
  saleGoldRate: 0,
};
const initialState: LivePrice = {
  message: "",
  msgKey: "",
  pricedata: LivePriceDataIntitial,
};

export type LivePriceStore = {
  updateMessage: (
    message: LivePrice["message"],
    msgKey: LivePrice["msgKey"]
  ) => void;
  updateLivePrice: (pricedata: LivePrice["pricedata"]) => void;
  resetLivePrice: () => void;
};

export const useLivePriceStore = create<LivePrice & LivePriceStore>((set) => ({
  ...initialState,
  updateMessage: (message, msgKey) =>
    set({
      message,
      msgKey,
    }),
  updateLivePrice: (pricedata) => {
    set(
      produce((state: LivePrice) => {
        state.pricedata = pricedata;
      })
    );
  },
  resetLivePrice: () => set(initialState),
}));
